import { NotificationResourceType } from "@iventis/domain-model/model/notificationResourceType";
import { Notification } from "@iventis/domain-model/model/notification";
import { NotificationMapExportData } from "@iventis/domain-model/model/notificationMapExportData";
import { ExportStatus } from "@iventis/domain-model/model/exportStatus";
import { NotificationResourceData } from "@iventis/domain-model/model/notificationResourceData";
import { LayersCopiedStatus } from "@iventis/domain-model/model/layersCopiedStatus";
import { NotificationLayersImportData } from "@iventis/domain-model/model/notificationLayersImportData";
import { NotificationLayersCopyData } from "@iventis/domain-model/model/notificationLayersCopyData";
import { NotificationMapsCopyData } from "@iventis/domain-model/model/notificationMapsCopyData";
import { MapsCopiedStatus } from "@iventis/domain-model/model/mapsCopiedStatus";
import { NotificationStatus } from "./notification-status";

export const isNotificationInProgress = (notification: Notification<NotificationResourceData>) => {
    switch (notification.resourceType) {
        case NotificationResourceType.MapExport: {
            const data = notification.resourceData as NotificationMapExportData;
            return data.exportStatus !== ExportStatus.Completed && data.exportStatus !== ExportStatus.Failed;
        }
        case NotificationResourceType.LayersImport: {
            const data = notification.resourceData as NotificationLayersImportData;
            return !data.failed && !(data.mapLayersCreated && data.permissionsCreated);
        }
        case NotificationResourceType.LayersCopy: {
            const data = notification.resourceData as NotificationLayersCopyData;
            return data.status === LayersCopiedStatus.Processsing;
        }
        case NotificationResourceType.MapsCopy: {
            const data = notification.resourceData as NotificationMapsCopyData;
            return data.status === MapsCopiedStatus.Processing;
        }
        default:
            return false;
    }
};

export const getNotificationStatus = (notification: Notification<NotificationResourceData>): NotificationStatus => {
    switch (notification.resourceType) {
        case NotificationResourceType.MapsCopy: {
            const data = notification.resourceData as NotificationMapsCopyData;
            switch (data.status) {
                case MapsCopiedStatus.Processing:
                    return "in-progress";
                case MapsCopiedStatus.Completed:
                    return "completed";
                case MapsCopiedStatus.ValidationError:
                    return "validation-error";
                default:
                    return "in-progress";
            }
        }
        case NotificationResourceType.LayersCopy: {
            const data = notification.resourceData as NotificationLayersCopyData;
            switch (data.status) {
                case LayersCopiedStatus.Processsing:
                    return "in-progress";
                case LayersCopiedStatus.Completed:
                    return "completed";
                case LayersCopiedStatus.Failed:
                    return "failed";
                case LayersCopiedStatus.ValidationError:
                    return "validation-error";
                default:
                    return "in-progress";
            }
        }
        default:
            return isNotificationInProgress(notification) ? "in-progress" : "completed";
    }
};
